import React from "react";
import ProfileForm from "../../forms/account/ProfileForm";
import EditInstallerContainer from "../../containers/installers/EditInstallerContainer";
import Modal from "../../components/Modal";
import { useTranslation } from "react-i18next";
import { useTheme } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";

const Edit = ({ handleClose, open, profile }) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down("xs"));

  return (
    <Modal
      fullScreen={matches}
      open={open}
      onClose={handleClose}
      title={t("register.title_edit_profile")}
    >
      {profile ? (
        <EditInstallerContainer installer={profile}>
          {({ onSubmit, installer }) => (
            <ProfileForm onSubmit={onSubmit} initialValues={installer} />
          )}
        </EditInstallerContainer>
      ) : null}
    </Modal>
  );
};

export default Edit;
